import { parse, Kind } from "graphql";
function inferOperationType(query) {
  var _a;
  const match = /^\s*(query|mutation|subscription)/i.exec(query);
  const keyword = (_a = match == null ? void 0 : match[1]) == null ? void 0 : _a.toLowerCase();
  if (keyword === "mutation" || keyword === "subscription") {
    return keyword;
  }
  return "query";
}
function getDocumentMethod(query) {
  try {
    const operations = parse(query).definitions.filter(
      (def) => def.kind === Kind.OPERATION_DEFINITION
    );
    if (operations.length > 1) {
      return "mix";
    }
    const [operation] = operations;
    return operation ? operation.operation : "query";
  } catch {
    return inferOperationType(query);
  }
}
export {
  getDocumentMethod
};
//# sourceMappingURL=operation-method.js.map
